import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_REPORT_INBOUND = "GET_LIST_REPORT_INBOUND";
export const GET_LIST_REPORT_INBOUND_ERROR = "GET_LIST_REPORT_INBOUND_ERROR";
export const GET_LIST_REPORT_INBOUND_SUCCESS =
  "GET_LIST_REPORT_INBOUND_SUCCESS";

export const COUNT_LIST_REPORT_INBOUND = "COUNT_LIST_REPORT_INBOUND";
export const COUNT_LIST_REPORT_INBOUND_ERROR =
  "COUNT_LIST_REPORT_INBOUND_ERROR";
export const COUNT_LIST_REPORT_INBOUND_SUCCESS =
  "COUNT_LIST_REPORT_INBOUND_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  report: [],
  error: false,
  count: 0,
  loading: false,
};

export const inboundReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_REPORT_INBOUND:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_INBOUND_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case GET_LIST_REPORT_INBOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        report: [],
      };
    //count list
    case COUNT_LIST_REPORT_INBOUND:
      return {
        ...state,
      };
    case COUNT_LIST_REPORT_INBOUND_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_REPORT_INBOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const getListReportInbound = (
  from,
  to,
  number,
  groupId,
  contactCode
) => ({
  type: GET_LIST_REPORT_INBOUND,
  data: {
    from,
    to,
    number,
    groupId,
    contactCode,
  },
});

export const countListReportInbound = (where) => ({
  type: COUNT_LIST_REPORT_INBOUND,
  data: {
    where,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListReportInbound,
      countListReportInbound,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListReportInboundApi = (from, to, number, groupId, contactCode) => {
  return apiCaller.getData("/cloud-pbx/inbound-call/report", {
    from,
    to,
    number,
    groupId,
    contactCode,
  });
};
const countListReportInboundApi = (where) => {
  return apiCaller.getData("/cloud-pbx/inbound-call/report/count", {
    ...where,
  });
};

/**
 * sagas
 */

export const getListReportInboundFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_INBOUND);
    try {
      const res = yield call(
        getListReportInboundApi,
        action.data.from,
        action.data.to,
        action.data.number,
        action.data.groupId,
        action.data.contactCode
      );
      yield put({ type: GET_LIST_REPORT_INBOUND_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_REPORT_INBOUND_ERROR, error });
    }
  }
};

export const countReportInboundFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_REPORT_INBOUND);
    try {
      const res = yield call(countListReportInboundApi, action.data.where);
      yield put({ type: COUNT_LIST_REPORT_INBOUND_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_REPORT_INBOUND_ERROR, error });
    }
  }
};
